import React, {
  useContext,
  useEffect,
  useState
} from 'react';

import PropTypes from 'prop-types';

import { useSalesPackages } from 'src/Hooks/useDealGrid';

import {
  Checkbox,
} from 'src/Components/Common';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  ChevronRight,
  CloseIcon,
  SideDrawerBackIcon
} from '../Svg';

import './PrivacyCheckbox.css';

const PrivacyCheckbox = ({
  checked,
  onChange,
  showError
}) => {

  return (
    <div className='privacy-checkbox-wrapper'>
      <div className={`privacy-checkbox ${showError && 'privacy-checkbox-error'}  ${checked && 'privacy-checkbox-checked'}`}>

        <Checkbox
          checked={checked}
          onChange={onChange}
          value={checked} />

        <div className='privacy-checkbox-text'>By submitting my information, I confirm that I have read and understood Vodacom's contract <a className='privacy-checkbox-link' href='https://www.vodacom.co.za/vodacom/terms/fibre/vodacom-fibre' target='_blank'>Terms and Conditions</a> and <a className='privacy-checkbox-link' href='https://www.vodacom.co.za/vodacom/privacy-policy/terms?icmp=Home/Footer/PrivacyPolicy' target='_blank'>Privacy Policy</a>.</div>
      </div>
      
      { showError &&

        <div className='privacy-checkbox-error-message'>
          Please agree to the T&Cs 
        </div>
      }
    </div>
  );
};

PrivacyCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool
};

export default PrivacyCheckbox;